import React, { useState, ChangeEvent, FormEvent } from "react";
import { toast } from "react-toastify";
import Title from "../../../components/Admin/Title";
import { Form, Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../../../components/UserContext";
import {
  faInstagram,
  faTiktok,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

export default function UploadShort() {
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [video, setVideo] = useState<File | null>(null);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [validated, setValidated] = useState(false);

  // Capturar el archivo binario del input
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setVideo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: any) => {
    if (token == null) return;

    e.preventDefault();

    const form = e.currentTarget;

    setValidated(true);

    if (!form.checkValidity()) {
      return;
    }

    if (!video) {
      toast.error("Video is required");
      return;
    }

    setLoading(true);

    const BASE_URL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    // 1. Creamos el contenedor FormData
    const formData = new FormData();

    // 2. Metemos el archivo y los textos con las claves que espera tu backend
    formData.append("video", video); // Esto llegará a Node como req.files.video
    formData.append("title", title); // Esto llegará a Node como req.body.title
    formData.append("description", description); // Esto llegará a Node como req.body.description
    formData.append("user", user);
    formData.append("token", JSON.parse(token).token);

    try {
      const response = await fetch(`${BASE_URL}/api/admin/upload-short`, {
        method: "POST",
        body: formData, // <-- Le pasamos el formData completo aquí
        // IMPORTANTE: Deja los headers vacíos. No pongas "Content-Type".
        // El navegador se encarga de configurarlo automáticamente.
      });

      if (response.status === 401) {
        const data = await response.json();

        // Decide el mensaje basado en la plataforma
        const message =
          data.platform === "tiktok"
            ? "TikTok authentication complete."
            : "YouTube authentication complete.";

        const authWindow = window.open(
          data.authUrl,
          "_blank",
          "width=600,height=700",
        );

        const timer = setInterval(() => {
          if (authWindow?.closed) {
            clearInterval(timer);
            toast.warning(message + " Please try uploading the video again.");
          }
        }, 1000);
      } else if (response.ok) {
        const data = await response.json();

        if (data.success) {
          // ✅ Toast de éxito en inglés
          toast.success(
            "Short published successfully on YouTube, TikTok and Instagram! 🚀",
          );

          // Opcional: limpiar el formulario tras el éxito
          setVideo(null);
          setTitle("");
          setDescription("");
          setValidated(false);
        } else {
          // ❌ Toast de error devuelto por el servidor
          toast.error(`Error: ${data.error || "Failed to upload reels"}`);
        }
      }
    } catch (error) {
      console.error("Error connecting to the server:", error);
      // ❌ Toast de error de conexión en inglés
      toast.error("An error occurred while connecting to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Upload Short/Reel" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group className="form-group" as={Col} md="12">
            <Form.Label>Title (*)</Form.Label>
            <Form.Control
              type="text"
              required
              value={title}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setTitle(e.target.value)
              }
            />
            <Form.Control.Feedback type="invalid">
              Field required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="form-group" as={Col} md="12">
            <Form.Label>Description (*)</Form.Label>

            <Form.Control
              type="text"
              required
              value={description}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                setDescription(e.target.value)
              }
            />
            <Form.Control.Feedback type="invalid">
              Field required
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="form-group" as={Col} md="12">
            <Form.Label>Video (*)</Form.Label>
            <Form.Control
              type="file"
              accept="video/*"
              required
              onChange={handleFileChange}
            />
            <Form.Control.Feedback type="invalid">
              Field required
            </Form.Control.Feedback>
          </Form.Group>

          <div className="text-center">
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button variant="primary" type="submit">
                {"Upload Video to "}
                <FontAwesomeIcon icon={faYoutube} />
                {"Shorts, "}
                <FontAwesomeIcon icon={faInstagram} />
                {"Reels & "}
                <FontAwesomeIcon icon={faTiktok} />
                {"TikTok"}
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
}
